"use client";

import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { getDictionary, normalizeLocale } from "@/i18n/dictionaries";
import styles from "./layout.module.css";

export function Footer() {
  const locale = normalizeLocale(useSearchParams().get("lang"));
  const dictionary = getDictionary(locale);
  const groups = [
    {
      title: dictionary.footer.designAndCreate,
      items: [
        { label: dictionary.footer.uploadGuide, href: `/design-and-create?lang=${locale}` },
        { label: dictionary.footer.printedModels, href: `/to-know-3d-print?lang=${locale}` },
        { label: dictionary.footer.materialsCraft, href: `/design-guide?lang=${locale}#materials` },
        { label: dictionary.footer.onlineTools, href: `/diy?lang=${locale}` }
      ]
    },
    {
      title: dictionary.footer.sellWorks,
      items: [
        { label: dictionary.footer.openStudio, href: `/sale-works?lang=${locale}` },
        { label: dictionary.footer.manageStudio, href: `/sale-works?lang=${locale}` }
      ]
    },
    {
      title: dictionary.footer.shoppingHelp,
      items: [
        { label: dictionary.footer.ordersShipping, href: `/shopping-assist?lang=${locale}` },
        { label: dictionary.footer.logistics, href: `/shopping-assist?lang=${locale}` },
        { label: dictionary.footer.refund, href: `/shopping-assist?lang=${locale}` }
      ]
    },
    {
      title: dictionary.footer.learn3DPrinting,
      items: [
        { label: dictionary.footer.modelingTools, href: `/to-know-3d-print?lang=${locale}` },
        { label: dictionary.footer.modelTools, href: `/design-guide?lang=${locale}` },
        { label: dictionary.footer.printingNews, href: `/to-know-3d-print?lang=${locale}` },
        { label: dictionary.footer.makers, href: `/works?lang=${locale}` }
      ]
    },
    {
      title: dictionary.footer.hiSpark,
      items: [
        { label: dictionary.footer.followUs, href: `/about?lang=${locale}` },
        { label: dictionary.footer.contactUs, href: `/about?lang=${locale}` },
        { label: dictionary.footer.joinUs, href: `/about?lang=${locale}` },
        { label: dictionary.footer.cooperation, href: `/about?lang=${locale}` }
      ]
    }
  ];

  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        {groups.map((group) => (
          <section key={group.title} className={styles.footerGroup}>
            <h2>{group.title}</h2>
            {group.items.map((item) => (
              <Link key={item.label} href={item.href}>
                {item.label}
              </Link>
            ))}
          </section>
        ))}
      </div>
      <p className={styles.copyright}>{dictionary.footer.copyright}</p>
    </footer>
  );
}
